<template>
  <div>
    <Header />
    <div class="o-container--">
      <Now />
      <Editions />
      <TrackList />
      <footer class="o-section__footer c-hitlist__footer">
        <HitlistPagination />
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from './Header';
import Now from './Now';
import Editions from './Editions';
import HitlistPagination from './HitlistPagination'
import TrackList from './TrackList';
export default {
  name: 'Hitlist',
  components: { Header, Now,TrackList, Editions, HitlistPagination },
  props: [
    'hitlistId',
    'editionId',
  ],
  computed: {
    ...mapGetters({
      tracks: 'hitlist/displayedTracks',
      showLoadMore: 'hitlist/hasMore'
    }),
  },
  watch: {
    tracks() {
      // Adding / Removing / Searching changes tracks, which changes height. Mobile app needs to know about that
      this.$nextTick(() => document.dispatchEvent(new Event('page:heightChanged')))
    }
  },
  created() {
    const { hitlistId, editionId } = this;
    this.$store.dispatch('hitlist/setHitlist', { hitlistId, editionId });
  },
};
</script>
